import { MagicTableCellLink } from '@sequencehq/core-components'

export const InvoiceLinkCell = ({
  invoice
}: {
  invoice: { id: string; name: string } | null | undefined
}) => {
  if (!invoice) {
    return null
  }

  return (
    <MagicTableCellLink to={`/invoices/${invoice.id}`} label={invoice.name} />
  )
}
